import { render, staticRenderFns } from "./appDropdownItem.vue?vue&type=template&id=e4dfec3c"
import script from "./appDropdownItem.vue?vue&type=script&lang=js"
export * from "./appDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./appDropdownItem.vue?vue&type=style&index=0&id=e4dfec3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports